@if (cancellationConfirmed) {
    <div class="container mt-5" [attr.data-testid]="'find-reservation-cancellation-confirmed'">
        <h2>{{'fr.cancellationConfirmedTitle'|translate}}</h2>

        <div class="content">
            <p class="my-3">{{'fr.cancellationConfirmedText'|translate}}</p>
            <p-button (click)="navigateHome()">{{"fr.BackToStart"|translate}}</p-button>

        </div>
    </div>
}
@else {
    <div class="container mt-5">
        <app-pim-notification phase="Cancellation"></app-pim-notification>
    </div>
    @if (!foundReservation) {
        <div class="container mt-5" [attr.data-testid]="'find-reservation'">
            <h2>{{'fr.FindYourReservation'|translate}}</h2>

            <div class="content">
                <form [formGroup]="findResForm">
                    <div class="row">
                        @if (hotelList && hotelList.length > 1) {
                            <div class="col-12 col-md-6 col-lg-4 mb-3 relative">
                                <label for="hotel">{{"fr.Hotel"|translate}} <span class="pr-required" aria-label="'pr.required'|translate">*</span></label>
                                <p-iconfield>
                                    <p-select
                                    id="hotel"
                                    formControlName="hotel"
                                    [options]="hotelList"
                                    optionLabel="hotelName"
                                    optionValue="hotelCode"
                                    [placeholder]="'fr.selectAHotel' | translate"
                                    [attr.data-testid]="'find-reservation-hotel'"
                                    >
                                        <ng-template pTemplate="dropdownicon">
                                            <p-button icon="pi pi-check" aria-label="Toggle dropdown" [rounded]="true" [text]="true">
                                                <span class="material-symbols-outlined">keyboard_arrow_down</span>
                                            </p-button>
                                        </ng-template>
                                    </p-select>
                                    <app-profile-validation-icon [control]="findResForm.get('hotel')" class="for-select"></app-profile-validation-icon>
                                </p-iconfield>
                            </div>
                        }

                        <div class="col-12 col-md-6 col-lg-4 mb-3 relative">
                            <label for="confirmationNumber">{{"fr.ConfirmationNumber"|translate}} <span class="pr-required" aria-label="'pr.required'|translate">*</span></label>
                            <p-iconfield>
                                <input id="confirmationNumber" class="w-100" pInputText  type="text" formControlName="confirmationNumber" required [attr.data-testid]="'find-reservation-confirmation-number'">
                                <app-profile-validation-icon [control]="findResForm.get('confirmationNumber')"></app-profile-validation-icon>
                            </p-iconfield>
                        </div>

                        <div class="col-12 col-md-6 col-lg-4 mb-3 relative">
                            <label for="email">{{"fr.EmailAddress"|translate}} <span class="pr-required" aria-label="'pr.required'|translate">*</span></label>
                            <p-iconfield>
                                <input id="email" class="w-100" pInputText  type="text" formControlName="email" required [attr.data-testid]="'find-reservation-email'">
                                <app-profile-validation-icon [control]="findResForm.get('email')"></app-profile-validation-icon>
                            </p-iconfield>
                        </div>
                    </div>

                </form>

                @if (showSearchError) {
                    <p-message severity="error" class="mt-3 d-block" [attr.data-testid]="'find-reservation-error'">
                        <span class="material-symbols-outlined">
                            error
                        </span> {{"fr.reservationNotFoundError"|translate}}
                    </p-message>
                }

                @if (showReservationAlreadyCancelledError) {
                    <p-message severity="error" class="mt-3 d-block">
                        <span class="material-symbols-outlined">
                            error
                        </span> {{"fr.reservationCancelledError"|translate}}
                    </p-message>
                }

                <div class="find-reservation-bottom-buttons mt-3">
                    <p-button [outlined]="true" (click)="navigateHome()" [attr.data-testid]="'find-reservation-back'">{{"fr.BackToStart"|translate}}</p-button>
                    <p-button (click)="findReservation()" [attr.data-testid]="'find-reservation-search'">{{"fr.Search"|translate}}</p-button>
                </div>

            </div>

        </div>
    }

    @if (foundReservation) {

        <div class="container mt-5" [attr.data-testid]="'find-reservation-yours'">
            <h2>{{'fr.YourReservation'|translate}}</h2>

            @if (foundReservationIsTable) {
                <app-confirmation-tabledetails [reservation]="foundReservation"></app-confirmation-tabledetails>
            }
            @else {
                <app-confirmation-commondetails [reservation]="foundReservation" [isMultiRoomBooking]="false"></app-confirmation-commondetails>


                <h4 class="room-details-title mt-5">{{'cn.roomDetails' | translate}}</h4>
                <app-confirmation-roominfo [roomInfo]="foundReservation"  [isMultiRoomBooking]="false"></app-confirmation-roominfo>
            }

            <p class="d-print-none mt-3">{{"fr.modifyInstructions"|translate}}</p>

            @if (showCancelReservationError) {
                <p-message severity="error" class="my-3 d-block d-print-none" [attr.data-testid]="'find-reservation-error'">
                    <span class="material-symbols-outlined">
                        error
                    </span> {{"fr.cannotCancelError"|translate}}
                </p-message>
            }

            <div class="find-reservation-bottom-buttons d-print-none">
                <p-button [outlined]="true" (click)="navigateHome()" [attr.data-testid]="'find-reservation-go-home'">{{"fr.BackToStart"|translate}}</p-button>
                <p-button (click)="print();">{{"cn.Print"|translate}}</p-button>
                @if (foundReservation.roomRate.rate.cancelPolicyCode == 'NOT_ALLOWED') {
                    <p-message severity="info" class="d-block d-print-none" [attr.data-testid]="'find-reservation-cancel-not-possible'">
                        {{"fr.cancellingOnlineNotPossible"|translate}}
                    </p-message>
                }
                @else {
                    <p-button (click)="cancelReservation($event)" [attr.data-testid]="'find-reservation-cancel-reservation'">{{"fr.cancelReservation"|translate}}</p-button>
                }
                <p-confirmpopup />

            </div>
        </div>


    }
}
